// Country dial codes (ISO 3166-1 alpha-2 + international dial code + Arabic name).
// UAE ships first because 80%+ of visitors are UAE-based.
// Flag images are sourced by iso code from https://flagcdn.com.
const COUNTRIES = [
  { iso: "AE", name: "United Arab Emirates", name_ar: "الإمارات العربية المتحدة", dial: "+971" },
  { iso: "SA", name: "Saudi Arabia", name_ar: "المملكة العربية السعودية", dial: "+966" },
  { iso: "QA", name: "Qatar", name_ar: "قطر", dial: "+974" },
  { iso: "KW", name: "Kuwait", name_ar: "الكويت", dial: "+965" },
  { iso: "BH", name: "Bahrain", name_ar: "البحرين", dial: "+973" },
  { iso: "OM", name: "Oman", name_ar: "عُمان", dial: "+968" },
  { iso: "PS", name: "Palestine", name_ar: "فلسطين", dial: "+970" },
  { iso: "JO", name: "Jordan", name_ar: "الأردن", dial: "+962" },
  { iso: "LB", name: "Lebanon", name_ar: "لبنان", dial: "+961" },
  { iso: "EG", name: "Egypt", name_ar: "مصر", dial: "+20" },
  { iso: "SY", name: "Syria", name_ar: "سوريا", dial: "+963" },
  { iso: "IQ", name: "Iraq", name_ar: "العراق", dial: "+964" },
  { iso: "YE", name: "Yemen", name_ar: "اليمن", dial: "+967" },
  { iso: "SD", name: "Sudan", name_ar: "السودان", dial: "+249" },
  { iso: "LY", name: "Libya", name_ar: "ليبيا", dial: "+218" },
  { iso: "TN", name: "Tunisia", name_ar: "تونس", dial: "+216" },
  { iso: "DZ", name: "Algeria", name_ar: "الجزائر", dial: "+213" },
  { iso: "MA", name: "Morocco", name_ar: "المغرب", dial: "+212" },
  { iso: "MR", name: "Mauritania", name_ar: "موريتانيا", dial: "+222" },
  { iso: "GB", name: "United Kingdom", name_ar: "المملكة المتحدة", dial: "+44" },
  { iso: "US", name: "United States", name_ar: "الولايات المتحدة", dial: "+1" },
  { iso: "CA", name: "Canada", name_ar: "كندا", dial: "+1" },
  { iso: "IN", name: "India", name_ar: "الهند", dial: "+91" },
  { iso: "PK", name: "Pakistan", name_ar: "باكستان", dial: "+92" },
  { iso: "BD", name: "Bangladesh", name_ar: "بنغلاديش", dial: "+880" },
  { iso: "LK", name: "Sri Lanka", name_ar: "سريلانكا", dial: "+94" },
  { iso: "NP", name: "Nepal", name_ar: "نيبال", dial: "+977" },
  { iso: "PH", name: "Philippines", name_ar: "الفلبين", dial: "+63" },
  { iso: "AU", name: "Australia", name_ar: "أستراليا", dial: "+61" },
  { iso: "NZ", name: "New Zealand", name_ar: "نيوزيلندا", dial: "+64" },
  { iso: "SG", name: "Singapore", name_ar: "سنغافورة", dial: "+65" },
  { iso: "MY", name: "Malaysia", name_ar: "ماليزيا", dial: "+60" },
  { iso: "ID", name: "Indonesia", name_ar: "إندونيسيا", dial: "+62" },
  { iso: "TH", name: "Thailand", name_ar: "تايلاند", dial: "+66" },
  { iso: "HK", name: "Hong Kong", name_ar: "هونغ كونغ", dial: "+852" },
  { iso: "CN", name: "China", name_ar: "الصين", dial: "+86" },
  { iso: "JP", name: "Japan", name_ar: "اليابان", dial: "+81" },
  { iso: "KR", name: "South Korea", name_ar: "كوريا الجنوبية", dial: "+82" },
  { iso: "TR", name: "Turkey", name_ar: "تركيا", dial: "+90" },
  { iso: "IR", name: "Iran", name_ar: "إيران", dial: "+98" },
  { iso: "IL", name: "Israel", name_ar: "إسرائيل", dial: "+972" },
  { iso: "DE", name: "Germany", name_ar: "ألمانيا", dial: "+49" },
  { iso: "FR", name: "France", name_ar: "فرنسا", dial: "+33" },
  { iso: "IT", name: "Italy", name_ar: "إيطاليا", dial: "+39" },
  { iso: "ES", name: "Spain", name_ar: "إسبانيا", dial: "+34" },
  { iso: "PT", name: "Portugal", name_ar: "البرتغال", dial: "+351" },
  { iso: "NL", name: "Netherlands", name_ar: "هولندا", dial: "+31" },
  { iso: "BE", name: "Belgium", name_ar: "بلجيكا", dial: "+32" },
  { iso: "CH", name: "Switzerland", name_ar: "سويسرا", dial: "+41" },
  { iso: "AT", name: "Austria", name_ar: "النمسا", dial: "+43" },
  { iso: "SE", name: "Sweden", name_ar: "السويد", dial: "+46" },
  { iso: "NO", name: "Norway", name_ar: "النرويج", dial: "+47" },
  { iso: "DK", name: "Denmark", name_ar: "الدنمارك", dial: "+45" },
  { iso: "FI", name: "Finland", name_ar: "فنلندا", dial: "+358" },
  { iso: "IE", name: "Ireland", name_ar: "أيرلندا", dial: "+353" },
  { iso: "GR", name: "Greece", name_ar: "اليونان", dial: "+30" },
  { iso: "PL", name: "Poland", name_ar: "بولندا", dial: "+48" },
  { iso: "RU", name: "Russia", name_ar: "روسيا", dial: "+7" },
  { iso: "UA", name: "Ukraine", name_ar: "أوكرانيا", dial: "+380" },
  { iso: "RO", name: "Romania", name_ar: "رومانيا", dial: "+40" },
  { iso: "CZ", name: "Czech Republic", name_ar: "التشيك", dial: "+420" },
  { iso: "HU", name: "Hungary", name_ar: "المجر", dial: "+36" },
  { iso: "BR", name: "Brazil", name_ar: "البرازيل", dial: "+55" },
  { iso: "MX", name: "Mexico", name_ar: "المكسيك", dial: "+52" },
  { iso: "AR", name: "Argentina", name_ar: "الأرجنتين", dial: "+54" },
  { iso: "ZA", name: "South Africa", name_ar: "جنوب أفريقيا", dial: "+27" },
  { iso: "NG", name: "Nigeria", name_ar: "نيجيريا", dial: "+234" },
  { iso: "KE", name: "Kenya", name_ar: "كينيا", dial: "+254" },
  { iso: "ET", name: "Ethiopia", name_ar: "إثيوبيا", dial: "+251" },
  { iso: "GH", name: "Ghana", name_ar: "غانا", dial: "+233" },
  { iso: "TZ", name: "Tanzania", name_ar: "تنزانيا", dial: "+255" },
  { iso: "UG", name: "Uganda", name_ar: "أوغندا", dial: "+256" },
];

export default COUNTRIES;
